import { ElementSchemaRegistry } from '@angular/compiler';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AttachmentsDetailComponent } from 'src/app/attachments/attachments-detail/attachments-detail.component';
import { AttachmentsService } from 'src/app/attachments/attachments.service';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { ViewsService } from 'src/app/core/view/views.service';
import { LoginService } from 'src/app/login/login.service';
import { MailingDetailComponent } from 'src/app/mailing/mailing-detail/mailing-detail.component';
import { OrganizationsContactsDetailComponent } from 'src/app/organizations/organizations-detail/organizations-contacts-detail/organizations-contacts-detail.component';
import { OrganizationsDetailGeneralComponent } from 'src/app/organizations/organizations-detail/organizations-detail-general/organizations-detail-general.component';
import { MeetingsService } from 'src/app/organizations/organizations-detail/organizations-meetings-detail/meetings.service';
import { OrganizationsMeetingsDetailComponent } from 'src/app/organizations/organizations-detail/organizations-meetings-detail/organizations-meetings-detail.component';
import { TransactionsDetailComponent } from 'src/app/transactions/transactions-detail/transactions-detail.component';
import { TransactionsService } from 'src/app/transactions/transactions.service';
import { UsersService } from '../../users/users.service';
import { TasksStatusService } from '../tasks-status.service';
import { TasksService } from '../tasks.service';
import { Location } from '@angular/common';
import { CustomHistoryService } from '../../core/customHistory.service';

@Component({
  selector: 'app-tasks-detail',
  templateUrl: './tasks-detail.component.html',
  styleUrls: ['./tasks-detail.component.scss']
})
export class TasksDetailComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  public viewConfig: any = {
    showCancel: false
  };
  private config: any = {};
  public task: any = {
    responsible_user_id: parseInt(this.loginService.get("userId")),
    task_action_scheduled_date: new Date()
  };
  public action: any = {
    task_action_scheduled_date: new Date()
  };
  public tasks_status: any = [];
  public tasksHistories: any = [];
  public showNextButton: boolean = false;
  public showPrevButton: boolean = false;
  private firstTime: boolean = true;
  public task_prev_id: number;
  public task_next_id: number;
  public task_prev;
  public task_next;
  public origin;
  public tooltip_info = {
    show: false,
    mode: "",
    subject: "",
    contact: "",
    organization: "",
    responsible: "",
    last_action_date: "",
  };
  public xPos = "0px";
  public yPos = "0px";
  public entered = false;
  //TODO: Para que no se vea el botón "cancelar" de la vista:
  public componentByRoute = false;

  public dialogRef: DynamicDialogRef = null;

  //public id: number = 0;
  //public organization_id: number = 0;


  constructor(
    private injector: Injector,
    private tasksService: TasksService,
    private tasksStatusService: TasksStatusService,
    private meetingsService: MeetingsService,
    private attachmentsService: AttachmentsService,
    private transactionsService: TransactionsService,
    private loginService: LoginService,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private coreDialogService: CoreDialogService,
    private viewsService: ViewsService,
    private usersService: UsersService,
    private customHistoryService: CustomHistoryService
  ) {
    this.dialogRef = this.injector.get(DynamicDialogRef, null);
    const dialogConfig = this.injector.get(DynamicDialogConfig, null);
    if (dialogConfig) {
      this.viewConfig.showCancel = true;
      this.config = dialogConfig;
    } else {
      this.route.params.subscribe(params => {
        this.config.data = {
          id: parseInt(params['id']),
          organization_id: parseInt(params['organization_id']),
          transaction_id: parseInt(params['transaction_id'])
        };
        if (params["origin"]) {
          this.config.data.origin = params["origin"];
          this.origin = params["origin"];
        }
      });
    }
    if (this.config.data.organization_id != null && this.config.data.organization_id > 0) {
      this.task.organization_id = this.config.data.organization_id;
    }
  }

  sumDate(event) {
    this.task.task_action_scheduled_date = new Date(new Date().getTime() + (event.action.param * 24 * 60 * 60 * 1000));
    this.save(event);
  }

  ngOnInit(): void {
    //console.log("config ->", this.config);
    this.loadTasksStatus();

    if (this.config.data.id != null) this.loadData(this.config.data.id);
    this.route.params.subscribe(params => {
      if (params['id'] != null) this.loadData(params['id']);
    });

  }

  loadData(id) {
    if (id != 0) {
      this.tasksService.get(id).subscribe(
        data => {
          //Si vuelven atras a una tarea borrada se redirecciona a crear nueva.
          if (data != null) {
            this.task = data;
          } else {
            this.router.navigate(['/tasks/', (this.task.organization_id ? this.task.organization_id : 0), 0]);
          }
          if (this.firstTime) {
            this.change(0);//NEXT
            this.change(1);//PREV
            this.getNextPrev(false);
            this.getNextPrev(true);
            this.firstTime = false;
          }
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    } else {
      var now = new Date();
      var nowMultiple = now.setMinutes(Math.ceil(now.getMinutes() / 15) * 15);
      this.task.date = new Date(nowMultiple);
      this.task.task_action_scheduled_date = new Date(nowMultiple).toISOString();
      //Estamos creando, no se muestran los botones de izq/der
      this.showNextButton = false;
      this.showPrevButton = false;
    }
  }

  loadTasksStatus() {
    this.tasksStatusService.all({}).subscribe(
      data => {
        this.tasks_status = data.rows;
        this.findDefaultStatus();
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
  }

  saveIfAllFormsAreValid(event: any) {
    //Valida que TODOs los formularios de la vista son válidos sino no deja guardar.
    var formsValid = this.view.getAllFormsFromViewValid();
    if (!formsValid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    } else {

      this.isDuplied(this.task, event);

    }
  }

  save(event: any) {
    if (event != null && !event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    if (typeof this.task.id === "undefined") {
      if (this.task.transaction_id == null || this.task.transaction_id == 0) this.task.transaction_id = this.config.data.transaction_id;
      this.task.date = new Date();
      if (this.action.task_action_id != null && this.action.task_action_scheduled_date != null) {
        this.task.task_action_id = this.action.task_action_id;
        if (this.action.task_action_description != null) this.task.task_action_description = this.action.task_action_description;
        this.task.task_action_scheduled_date = this.action.task_action_scheduled_date;
      }
      this.task.task_action_description = this.task.message;

      this.tasksService.add(this.task).subscribe(
        data => {
          if (this.dialogRef) this.dialogRef.close(data);
          else {
            this.task = data;
            this.router.navigate(["tasks", (this.task.organization_id == null ? 0 : this.task.organization_id), this.task.id]);
            //this.loadData(this.task.id);
            //this.view.fireEvent("tasksHistoryDetail.custom", "reload", this.task);
          }
          this.messageService.add({ closable: false, severity: 'success', summary: "Actividad añadida correctamente." });
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      );
    } else {
      this.task.task_action_description = this.task.message;
      this.tasksService.save(this.task.id, this.task).subscribe(
        data => {
          this.task = data;
          this.messageService.add({ closable: false, severity: "success", detail: "Actividad guardada correctamente" });
          this.view.fireEvent("tasks.histories", "reload");
          this.view.fireEvent("tasksHistoryDetail.custom", "reload");
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      );
    }
  }

  findDefaultStatus() {
    if (typeof this.task.task_status_id == "undefined") {
      this.tasks_status.forEach(element => {
        if (element.is_default) {
          this.task.task_status_id = element.id;
        }
      });
    }
  }

  cancel(data: any) {
    if (this.dialogRef) {
      this.dialogRef.close(data);
    } else {
      this.router.navigate(['/tasks']);
    }/* else {
      if (history.length == 0) {
        this.router.navigate(['tasks']);
      } else {
        history.back();
      }
    }*/
  }

  goToCalendar() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.router.navigate(['/calendar']);
  }

  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar la actividad con asunto '" + this.task.subject + "'?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.tasksService.delete(this.task.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Actividad eliminada correctamente" });
            if (this.dialogRef != null) {
              this.dialogRef.close();
            } else {
              //this._location.back();
              if (this.customHistoryService.getBackHistory() != null) {
                this.router.navigateByUrl(this.customHistoryService.getBackHistory());
              } else {
                this.router.navigate(['/tasks']);
              }

            }
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        );
      },
      reject: () => {

      }
    });
  }

  viewMeeting(meeting) {
    const ref = this.dialogService.open(OrganizationsMeetingsDetailComponent, {
      data: {
        id: meeting ? meeting.organization_id : this.task.organization_id,
        contactId: meeting ? meeting.contact_id : this.task.contact_id,
        meetingId: meeting ? meeting.id : 0,
        taskId: this.task.id,
        deactivated: meeting ? true : false
      },
      //header: meeting ? "Detalles de la reunión" : "Nueva reunión",
      width: '70%',
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      if (data) {
        this.task.meeting_id = data.id;
        this.view.fireEvent("tasks.meetings", "reload");
      }
    });
  }

  deleteMeeting(meeting) {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el contacto " + meeting.subject + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.meetingsService.delete(meeting.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            this.view.fireEvent("tasks.meetings", "reload");
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        );
      },
      reject: () => {

      }
    })
  }
  downloadFile(attachment) {
    this.attachmentsService.download(attachment.guid);
  }

  viewAttachment(attachment) {
    const ref = this.dialogService.open(AttachmentsDetailComponent, {
      data: {
        id: attachment ? attachment.id : 0,
        entity_id: 4,
        entity_pk_id: this.task.id,
        organization_id: this.task.organization_id
      },
      // header: attachment ? "Detalles del adjunto" : "Nuevo adjunto",
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.view.fireEvent("tasks.attachments", "reload");
    });
  }

  deleteAttachment(attachment) {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el adjunto " + attachment.filename + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.attachmentsService.delete(attachment.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            this.view.fireEvent("tasks.attachments", "reload");
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        );
      },
      reject: () => {

      }
    });
  }

  viewTransaction(event, data, transaction_type_id, code) {
    this.cancel(null);
    this.router.navigate(['/transactions/', transaction_type_id, (this.task.contact_id ? this.task.contact_id : 0), (this.task.organization_id ? this.task.organization_id : 0), this.task.id, (data?.id ? data.id : 0)]);
    /*const ref = this.dialogService.open(TransactionsDetailComponent, {
      data: {
        id: data ? data.id : 0,
        transaction_type_id: transaction_type_id,
        organization_id: this.task.organization_id,
        contactId: this.task.contact_id,
        from_task_id: this.task.id
      },
      //header: transaction ? "Detalles de " + transaction_name : "Nueva " + transaction_name,
      width: '70%',
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.loadTaskTransaction();
      this.view.fireEvent("task.oportunities", "reload");
      this.view.fireEvent("task.sales", "reload");
      this.view.fireEvent(event.component, "reload");
    });*/
  }

  loadTaskTransaction() {
    if (this.task.id == null) return;
    this.tasksService.get(this.task.id).subscribe(
      data => {
        this.task.transaction_id = data["transaction_id"];
        this.view.fireEvent("tasks.oportunities", "reload");
        this.view.fireEvent("tasks.sales", "reload");
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }
  deleteTransaction(transaction) {
    var code = transaction.transactionType.code;
    this.coreDialogService.confirm({
      message: "¿Quieres borrar la transacción?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.transactionsService.delete(transaction.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            this.view.fireEvent("tasks.oportunities", "reload");
            this.view.fireEvent("tasks.sales", "reload");
            this.view.fireEvent(code, "reload");
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        );
      },
      reject: () => {
      }
    });
  }

  newMail(emailAcc, template_type_code, searchRelated, other_entity, other_entity_pk_id) {
    const ref = this.dialogService.open(MailingDetailComponent, {
      data: {
        to: emailAcc,
        entity_id: (this.task.id ? 4 : other_entity),
        entity_pk_id: (this.task.id ? this.task.id : other_entity_pk_id),
        organization_id: this.task.organization_id,
        contact_id: this.task.contact_id,
        template_type_code: template_type_code,
        searchRelated: searchRelated
      },
      header: "Nuevo mensaje de correo",
      width: '70%',
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.view.fireEvent("organizations.preview.mails", "reload");
    });
  }

  link(object, unlink, type, ask = true) {
    //El task debe desvincularse o vincularse del transaction.
    var message = "";
    var result = "";

    if (unlink) {
      switch (type) {
        //Desenlazar:
        case "meeting":
          message = "¿Quieres desvincular la reunión " + object.subject + " de la actividad " + this.task.subject + "?";
          break;
        case "transaction":
          message = "¿Quieres desvincular la transacción " + object.description + " de la actividad " + this.task.subject + "?";
          break;
      }
      result = "Desvinculado correctamente";
    } else {
      //Enlazar:
      switch (type) {
        case "meeting":
          message = "¿Quieres vincular la reunión " + object.subject + " de la actividad " + this.task.subject + "?";
          break;
        case "transaction":
          message = "¿Quieres vincular la transacción " + object.description + " de la actividad " + this.task.subject + "?";
          break;
      }
      result = "Vinculado correctamente";
    };

    if (ask) {
      this.coreDialogService.confirm({
        message: message,
        icon: "pi pi-info-circle",
        accept: () => {
          if (unlink) {
            //Desenlazar:
            switch (type) {
              case "meeting":
                this.task.meeting_id = null
                break;
              case "transaction":
                this.task.transaction_id = null
                break;
            }
          } else {
            //Enlazar:
            switch (type) {
              case "meeting":
                this.task.meeting_id = object.id
                break;
              case "transaction":
                this.task.transaction_id = object.id;
                break;
            }
          };
          this.tasksService.link(this.task.id, this.task, type).subscribe(
            data => {
              this.messageService.add({ closable: false, severity: 'success', detail: result });
              switch (type) {
                case "meeting":
                  this.view.fireEvent("tasks.meetings", "reload");
                  break;
                case "transaction":
                  this.view.fireEvent("tasks.oportunities", "reload");
                  break;
              }
            },
            error => {
              this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
            }
          );
        },
        reject: () => {
        }
      });
    } else {
      //Enlazar:
      switch (type) {
        case "meeting":
          this.task.meeting_id = object.id
          break;
        case "transaction":
          this.task.transaction_id = object.id;
          break;
      }
      this.tasksService.link(this.task.id, this.task, type).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: 'success', detail: result });
          switch (type) {
            case "meeting":
              this.view.fireEvent("tasks.meetings", "reload");
              break;
            case "transaction":
              this.view.fireEvent("tasks.oportunities", "reload");
              break;
          }
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
        }
      );
    }
  }

  isDuplied(task, event) {
    if (event != null && !event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }

    this.tasksService.isDuplied(task).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: "Ya existe una actividad con estos datos proporcionados.",
            header: 'Error',
            icon: 'far, exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save(event);
        }
      },
      error => {
        console.log(error);
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }

  refreshAll() {
    this.loadData(this.task.id);
    //this.view.fireEvent("task.edit.general","reload");
    this.view.view?.configuration?.components?.forEach(component => {
      this.view.fireEvent(component.code, "reload");
    });
  }

  onEvent(event) {
    if (event.event == "closeDialog" && event.action.name == "closeDialog") this.dialogRef.close();
    if (event.event == "refreshAll" && event.action.name == "refreshAll") this.refreshAll();
    if (event.component == "tasks.edit.general") {
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel(null);
      if (event.event == "action" && event.action.name == "save") {
        this.saveIfAllFormsAreValid(event); //Validamos si todos los formularios son validos, si es así se llamará al isDuplied


      }
      if (event.event == "fieldAction" && event.action.name == "new-mail" && event.entityField.model_property == "organization.email") {
        this.newMail({ name: "", email: event.data.organization.email }, "MAIL", true, 1, event.data.organization.id);
      }
      if (event.event == "fieldAction" && event.action.name == "new-mail" && event.entityField.model_property == "contact.email") {
        this.newMail({ name: event.data.contact.fullname, email: event.data.contact.email }, "MAIL", true, 2, event.data.contact.id);
      }
    } else if (event.component == "tasks.histories") {
      //console.log(event);
      if (event.event == "action" && event.action.name == "save") this.saveIfAllFormsAreValid(event);//this.save(event);
      if (event.event == "action" && event.action.name == "registerTaskHistory") this.sumDate(event);
      if (event.event == "fieldAction" && event.action.name == "new-mail") {
        if (event.action.param == "INTERNAL") {
          //Cargamos los datos del usuario (o responsible_id o responsible_user_id)
          this.usersService.get(event.value).subscribe(
            (data: any) => {
              var toInfo = { name: data.name, email: data.email }
              this.newMail(toInfo, "MAIL_INTERNAL", false, 18, data.id);
            },
            error => {
              this.messageService.add({ severity: "error", detail: error.error.title });
            }
          );
        } else {
          this.newMail({ name: "", email: event.value }, "MAIL", false, 18, event.data.id);
        }
      }
    } else if (event.component == "tasks.meetings") {
      if (event.event == "action" && event.action.name == "add") this.viewMeeting(null);
      if (event.event == "action" && event.action.name == "edit") this.viewMeeting(event.data);
      if (event.event == "action" && event.action.name == "delete") this.deleteMeeting(event.data);
      if (event.event == "dblclick") this.viewMeeting(event.data);
      if (event.event == "action" && event.action.name == "unlink") this.link(event.data, true, "meeting");
      if (event.event == "action" && event.action.name == "link") this.link(event.data, false, "meeting");
      if (event.event == "action" && event.action.name == "calendar") this.goToCalendar();
    } else if (event.component == "tasks.attachments") {
      if (event.event == "action" && event.action.name == "add") this.viewAttachment(null);
      if (event.event == "action" && event.action.name == "delete") this.deleteAttachment(event.data);
      if (event.event == "dblclick") this.viewAttachment(event.data);
      if (event.event == "action" && event.action.name == "download") this.downloadFile(event.data);
    } else if (event.component == "tasks.oportunities") {
      if (event.event == "action" && event.action.name == "add") this.viewTransaction(event, null, 1, "oportunidad");
      if (event.event == "action" && event.action.name == "edit") this.viewTransaction(event, event.data, 1, "oportunidad");
      if (event.event == "action" && event.action.name == "delete") this.deleteTransaction(event.data);
      if (event.event == "dblclick") this.viewTransaction(event, event.data, 1, "oportunidad");
      if (event.event == "action" && event.action.name == "unlink") this.link(event, true, "transaction");
      if (event.event == "action" && event.action.name == "link") this.link(event.data, false, "transaction");
    } else if (event.component == "tasks.sales") {
      if (event.event == "action" && event.action.name == "add") this.viewTransaction(event, null, 2, "venta");
      if (event.event == "action" && event.action.name == "edit") this.viewTransaction(event, event.data, 2, "venta");
      if (event.event == "action" && event.action.name == "delete") this.deleteTransaction(event.data);
      if (event.event == "dblclick") this.viewTransaction(event, event.data, 2, "venta");
      if (event.event == "action" && event.action.name == "unlink") this.link(event.data, true, "transaction");
      if (event.event == "action" && event.action.name == "link") this.link(event.data, false, "transaction");
    } else if (event.component != "") {
      if (event.event == "dblclick") { this.viewTransaction(event, event.data, event.data.transaction_type_id, event.data.transactionType.code); }
      if (event.event == "action" && event.action.name == "add") this.viewTransaction(event, null, event.action.transaction_type_id, event.component);
      if (event.event == "action" && event.action.name == "edit") this.viewTransaction(event, event.data, event.data.transaction_type_id, event.data.transactionType.code);
      if (event.event == "action" && event.action.name == "delete") this.deleteTransaction(event.data);
    }
    if (event.component == "view" && event.event == "entity-loaded") {
      this.config.header = typeof (this.task.id) !== "undefined" ? "Detalles de la " + this.view.getEntityBaseName() : "Nueva " + this.view.getEntityBaseName();
    }
  }

  status_selected(id) {
    //comrpobar si puedo editarlo
    if (!this.loginService.canEditModel(this.task, this.view?.entity?.code)) {
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: "El usuario no tiene permisos para editar esta actividad" });
      return;
    }

    this.task.task_status_id = id;

    var formsValid = this.view.getAllFormsFromViewValid();
    if (!formsValid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    this.save({ valid: formsValid });
    /*
    if (this.task.id != null && this.task.id !== "undefined") {
      this.tasksService.save(id, this.task).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Estado actualizado correctamente" });
          this.loadData(this.task.id);
          this.view.fireEvent("tasksHistoryDetail.custom", "reload");
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      this.messageService.add({ closable: false, severity: "success", detail: "Estado asignado. No olvides guardar la actividad." });
    }*/
  }

  change(prev) {
    //Desde navegación.
    this.route.params.subscribe(params => {
      var next_id = params["next_id"];
      var prev_id = params["prev_id"];

      console.log(params);

      if (next_id > 0) {
        this.showNextButton = true;
        if (next_id > 0) this.task_next_id = params["next_id"];
      }
      if (prev_id > 0) {
        this.showPrevButton = true;
        if (prev_id > 0) this.task_prev_id = params["prev_id"];
      }
    });

    //Desde dialog
    if (!this.config.data.params) return;
    this.config.data.params.prev = (prev == 0 ? false : true);
    if (!prev) {
      this.task_next = this.config.data.nextTask;
      this.task_next_id = this.config.data.nextTask?.id;
      this.showNextButton = (this.task_next_id ? true : false);
    }
    if (prev) {
      this.task_prev = this.config.data.prevTask;
      this.task_prev_id = this.config.data.prevTask?.id;
      this.showPrevButton = (this.task_prev_id ? true : false);
    }

  }
  loadPrevNext(prev) {
    let newLoadTaskId = null;
    console.log(this.task_prev, this.config.data.prevTask);
    console.log(this.task_next, this.config.data.nextTask);
    if (prev && this.config.data.prevTask == null) {
      this.router.navigate(['/tasks/', (this.task_prev?.organization_id ? this.task_prev.organization_id : 0), this.task_prev_id]);
    }
    if (!prev && this.config.data.nextTask == null) {
      this.router.navigate(['/tasks/', (this.task_next?.organization_id ? this.task_next.organization_id : 0), this.task_next_id]);
    }


    if (prev && this.config.data.prevTask) {
      newLoadTaskId = this.config.data.prevTask.id;
      //this.router.navigate(['/tasks/', (this.task?.organization_id ? this.task.organization_id : 0), newLoadTaskId, (this.task_prev_id ? this.task_prev_id : 0), this.task.id]);
    }
    if (!prev && this.config.data.nextTask) {
      newLoadTaskId = this.config.data.nextTask.id;
      //this.router.navigate(['/tasks/', (this.task?.organization_id ? this.task.organization_id : 0), newLoadTaskId, this.task.id, (this.task_next_id ? this.task_next_id : 0)]);
    }
    var ret = {
      mode: prev ? "prev" : "next",
      id: newLoadTaskId
    };
    if (this.config.data.prevTask || this.config.data.nextTask) this.cancel(ret);
  }
  onMouseEnterButton(mode: string) {
    if (!this.entered) {
      //this.entered sirve para que no recalcule la posición tantas veces y así no haga lenta la pantalla.
      window.addEventListener("mousemove", (e) => {
        this.xPos = (e.clientX - 145) + "px";
        this.yPos = (e.clientY - 15) + "px";
      });
      this.entered = true;
      if (mode == "next") {
        this.tooltip_info.mode = "Siguiente tarea";
        this.tooltip_info.subject = "" + this.task_next?.subject;
        this.tooltip_info.responsible = this.task_next?.user?.name;
        this.tooltip_info.contact = this.task_next?.contact?.fullname;
        this.tooltip_info.last_action_date = this.task_next?.date;
        this.tooltip_info.organization = this.task_next?.organization.name
      } else {
        this.tooltip_info.mode = "Tarea anterior";
        this.tooltip_info.subject = "" + this.task_prev?.subject;
        this.tooltip_info.responsible = this.task_prev?.user?.name;
        this.tooltip_info.contact = this.task_prev?.contact?.fullname;
        this.tooltip_info.last_action_date = this.task_prev?.date;
        this.tooltip_info.organization = this.task_prev?.organization.name
      }
      this.tooltip_info.show = true;
    }
  }
  onMouseLeaveButton() {
    this.tooltip_info.show = false;
    this.entered = false;
  }

  getNextPrev(prev) {
    // Obtiene la cadena JSON del localStorage utilizando de clave la página de donde proviene.
    var paramsStringList = localStorage.getItem("tasks.list");
    var paramsStringHome = localStorage.getItem("home.tasks");
    var paramsStringOrganization = localStorage.getItem("organization.tasks");

    var paramsString = "{}";
    if (paramsStringList != null) paramsString = paramsStringList;
    if (paramsStringHome != null) paramsString = paramsStringHome;
    if (paramsStringOrganization != null) paramsString = paramsStringOrganization;

    // Convierte la cadena JSON en un objeto
    var params = JSON.parse(paramsString);

    // Limpia el objeto params eliminando los valores nulos
    for (var key in params) {
      if (params.hasOwnProperty(key) && params[key] === null) {
        delete params[key];
      }
    }
    params.prev = prev;
    params.viewedId = this.task.id;
    this.tasksService.getNextPrev(this.task.id, params).subscribe(
      data => {
        console.log("+++++++++++++++++++", data);

        if (prev) {
          this.task_prev_id = data.id;
          this.task_prev = data.task;
          if (this.task_prev_id > 0) this.showPrevButton = true;
        } else {
          this.task_next_id = data.id;
          this.task_next = data.task;
          if (this.task_next_id > 0) this.showNextButton = true;
        }
      },
      error => {

      }
    );
  }
}

